import { React } from 'Imports';
import { ListItemText, MenuItem } from 'MaterialUIComponents';
import DropdownMenuItemCheckbox from '$Components/FilterComponents/Filters/DropdownMenuItemCheckbox';
import { isEncompass } from '$Utilities/integrationPlatform';
import * as scssStyles from '$CSS/settings.scss';

const styles = require('$Components/FilterComponents/Filters/DropdownMenuItem.scss') as {
    highlight: string;
    secondaryLabel: string;
};

interface IDropdownMenuItemProps {
    value: string;
    checked: boolean;
    onChange: () => void;
    label: string;
    secondaryLabel?: string;
    searchFilter?: string;
    checkboxDisabled?: boolean;
    optionsFontSize?: number;
}

const DropdownMenuItem = (props: IDropdownMenuItemProps) => (
    <MenuItem
        value={props.value}
        disableRipple={true}
        sx={{
            padding: '4px 8px 4px 8px',
            backgroundColor: props.checkboxDisabled && props.checked ? '#0078D3 !important' : undefined,
        }}
        onClick={props.onChange}
    >
        {!props.checkboxDisabled && <DropdownMenuItemCheckbox checked={props.checked} onChange={props.onChange} />}
        <ListItemText
            primary={
                props.searchFilter ? (
                    <>
                        {props.label.split(new RegExp(`(${props.searchFilter})`, 'gi')).map((part, index) =>
                            part.toLowerCase() === props.searchFilter?.toLowerCase() ? (
                                <span key={index} className={styles.highlight}>
                                    {part}
                                </span>
                            ) : (
                                part
                            ),
                        )}
                    </>
                ) : (
                    props.label
                )
            }
            primaryTypographyProps={{
                noWrap: true,
                fontSize: props.optionsFontSize ? `${props.optionsFontSize}px` : isEncompass ? '14px' : '12px',
                fontWeight: isEncompass ? (props.checked ? 700 : 400) : 400,
                textOverflow: 'ellipsis',
                color: props.checkboxDisabled && props.checked ? '#fff' : scssStyles.customColor2,
                width: 'max-content',
                align: 'right',
            }}
            onClick={props.onChange}
        />
        {props.secondaryLabel &&
            (props.searchFilter ? (
                <span className={styles.secondaryLabel}>
                    {props.secondaryLabel.split(new RegExp(`(${props.searchFilter})`, 'gi')).map((part, index) =>
                        part.toLowerCase() === props.searchFilter?.toLowerCase() ? (
                            <span key={index} className={styles.highlight}>
                                {part}
                            </span>
                        ) : (
                            part
                        ),
                    )}
                </span>
            ) : (
                <span className={styles.secondaryLabel}>{props.secondaryLabel}</span>
            ))}
    </MenuItem>
);

export default DropdownMenuItem;
